<template>
  <!-- booking calender Intro start -->
  <Intro
    heading="booking calender"
    info="Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudian
      consectetur  et sint,a iste similique
      ipsum et sint."
  />

  <div class="grid justify-self-center justify-items-center">
    <img src="/assets/booking-calender.png" alt="" />
  </div>
</template>
<script>
import Intro from "../../../../global-components/Intro.vue";
export default {
  components: {
    Intro,
  },
};
</script>
<style></style>
